import {
  AUTO_STEP_NAME,
  HOME_FIN_STEPS,
  PULSING_VARIANTS,
  STEPS,
} from 'domain/enums'

const definePulsingVariant = ({ currentStep = {} }) => {
  if (currentStep?.rejectionReason) return PULSING_VARIANTS.REJECTED
  if (
    currentStep?.name === AUTO_STEP_NAME.LOAN_PAYMENT &&
    currentStep?.progress?.finishedAt
  ) {
    return PULSING_VARIANTS.PAYMENT
  }
  return PULSING_VARIANTS.PENDING
}

const definePulsingVariantHomeFin = ({ currentStep = {} }) => {
  if (currentStep === HOME_FIN_STEPS['Análise de crédito']) {
    return PULSING_VARIANTS.PENDING
  }
  if (currentStep === HOME_FIN_STEPS['Processos descontinuados']) {
    return PULSING_VARIANTS.REJECTED
  }
  if (currentStep === HOME_FIN_STEPS["Contratação e assinatura"]) {
    return PULSING_VARIANTS.PAYMENT
  }
  return PULSING_VARIANTS.INFO
}

const definePulsingAnimate = ({ pendingAction }) => {
  if (pendingAction?.length > 0) return true
  return false
}

const getStepName = ({ currentStep }) => STEPS[currentStep?.name] ?? ''

export {
  definePulsingAnimate,
  definePulsingVariant,
  getStepName,
  definePulsingVariantHomeFin,
}
